<div class="custom-header flex h-full flex-row items-center font-semibold">
  <div class="ml-[12px] flex" *ngIf="isRunning === false">
    <!-- <m-chart-icon
      class="mb-[2px] ml-5 flex cursor-pointer"
      [ngClass]="{
        'text-s500': showMiniCharts === true,
        'text-s400': showMiniCharts === false
      }"
      (click)="toggleShowMiniCharts()"
    ></m-chart-icon> -->

    <m-right-panel-icon
      class="text-s500 flex-shrink-0 cursor-pointer"
      (click)="toggleShowMiniCharts()"
      [isFilled]="showMiniCharts === true"
    ></m-right-panel-icon>
  </div>

  <div *ngIf="isRunning === true" class="relative ml-[25px] w-9">
    <ngx-spinner
      [name]="spinnerName"
      color="#0084d1"
      bdColor="#00000000"
      size="default"
      type="ball-pulse"
      [fullScreen]="false"
      [disableAnimation]="true"
      [zIndex]="10"
    >
    </ngx-spinner>
  </div>
</div>

<div *ngIf="showMiniCharts$ | async"></div>
